'use client'

import { useEmailConfirm } from '@/hooks/useEmailConfirm'
import { useEmailVerify } from '@/hooks/useEmailVerify'
import Button from 'lib/components/Button/Button'
import { TextInputStandalone } from 'lib/components/Form'
import Header from 'lib/components/Header/Header'
import Link from 'lib/components/Link/Link'
import Notification from 'lib/components/Notification/Notification'
import { useState } from 'react'

interface VerificationCodeProps {
  email: string
  onBack: () => void
  onSuccess: (token: string) => void
}

export default function VerificationCode({
  email,
  onBack,
  onSuccess,
}: VerificationCodeProps) {
  const [code, setCode] = useState('')
  const { loading, error, confirmCode } = useEmailConfirm()
  const { loading: resending, error: resendError, sendCode } = useEmailVerify()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const token = await confirmCode(email, code)
    if (token !== null) onSuccess(token)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Header as="h2" className="type-body-3 mb-4">
        Enter verification code
      </Header>
      <p className="type-body-8 mb-4">
        A code was sent via SMS to the mobile number on your account.
      </p>
      {(error || resendError) && (
        <Notification
          size="small"
          icon={{ icon: 'error' }}
          type="urgent"
          title={error || resendError}
          className="mb-4 !text-left"
        />
      )}
      <TextInputStandalone
        label="Verification code*"
        placeholder="Enter 6-digit code"
        name="code"
        inputMode="numeric"
        maxLength={6}
        disabled={loading}
        onChange={(val) => setCode(String(val ?? ''))}
      />
      <Button
        type="submit"
        className="!mt-4 w-full !type-body-11-bold md:!type-body-5"
        disabled={loading || code.length < 6}
      >
        {loading ? 'Verifying...' : 'Verify Code'}
      </Button>
      <div className="mt-4 flex items-center justify-between">
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault()
            onBack()
          }}
          className="md:!text-xs"
        >
          Back
        </Link>
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault()
            sendCode(email)
          }}
          className="md:!text-xs"
        >
          {resending ? 'Sending...' : 'Resend code'}
        </Link>
      </div>
    </form>
  )
}
